import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import VideoDraft from 'components/video-draft/'
import WebcamHtml from 'components/webcam-html/webcam-html'

const propTypes = {
  globalRecorder: PropTypes.string,
  video: PropTypes.shape({
    recorder: PropTypes.string,
  }).isRequired,
  isEmbedded: PropTypes.bool,
}

const defaultProps = {
  globalRecorder: '',
  isEmbedded: false,
}

const mapStateToProps = state => ({
  globalRecorder: state.global.recorder,
})

function Webcam(props) {
  switch (props.video.recorder) {
    case 'upload':
      return <VideoDraft isUpload={props.isEmbedded} {...props} />
    default:
      return <WebcamHtml {...props} />
  }
}

Webcam.propTypes = propTypes
Webcam.defaultProps = defaultProps

export default connect(mapStateToProps)(Webcam)
